import { createStyles, makeStyles } from '@material-ui/styles';
import * as classNames from 'classnames';
import * as React from 'react';
import { FC, useRef, useState } from 'react';
import mediaQueries from 'src/constants/responsive';
import spacing from 'src/constants/spacing';
import stylesheet, { mainColor, secondaryColor } from 'src/constants/stylesheet';
import { Language } from 'src/utils/Languages';
import ViewMonitor from 'src/utils/ViewMonitor';

const useStyles = makeStyles(() =>
    createStyles({
        newsletterContainer: {
            width: '100%',
            [mediaQueries.Mobile]: {
                paddingLeft: spacing.GutterGrid.Mobile / 2,
                paddingRight: spacing.GutterGrid.Mobile / 2,

                paddingBottom: spacing.Gutter.Mobile / 2,
            },
            [mediaQueries.Tablet]: {
                paddingLeft: spacing.GutterGrid.Tablet / 2,
                paddingRight: spacing.GutterGrid.Tablet / 2,

                paddingBottom: spacing.Gutter.Tablet / 2,
            },
            [mediaQueries.Laptop]: {
                paddingLeft: spacing.GutterGrid.Laptop / 2,
                paddingRight: spacing.GutterGrid.Laptop / 2,

                paddingBottom: spacing.Gutter.Laptop / 2,
            },
            [mediaQueries.Desktop]: {
                paddingLeft: spacing.GutterGrid.Desktop / 2,
                paddingRight: spacing.GutterGrid.Desktop / 2,

                paddingBottom: spacing.Gutter.Desktop / 2,
            },
            [mediaQueries.BigDesktop]: {
                width: `${2 / 3 * 100}%`,
                marginLeft: 'auto',
                paddingLeft: spacing.GutterGrid.BigDesktop / 2,
                paddingRight: spacing.GutterGrid.BigDesktop / 2,

                paddingBottom: spacing.Gutter.BigDesktop / 2,
            }
        },
        newsletterContainerInner: {
            [mediaQueries.Mobile]: {
                width: '100%',
            },
            [mediaQueries.AfterMobile]: {
                width: '50%',
            }
        },
        email: {
            width: '100%',
            outline: 'none',
            border: 'none',
            ...stylesheet.BoldText,
            fontSize: '1rem',
            padding: '5px 5px 5px 0',

            '&::placeholder': {
                color: secondaryColor
            }
        },
        emailFilled: {
            color: secondaryColor,

            '&:hover': {
                color: mainColor
            }
        },
        submitButton: {
            backgroundColor: 'transparent',
            border: 'none',
            fontSize: '1rem',
            padding: 0,
            cursor: 'pointer'
        },
        hide: {
            ...stylesheet.Hide,
            transitionDelay: '100ms'
        },
        show: {
            ...stylesheet.Show
        }
    }));

export type panelNewsletterProps = PanelNewsletterDto;

type Props = panelNewsletterProps;

const PanelNewsletter: FC<Props> = (props) => {
    const cls = useStyles();
    const [emailHasValue, setEmailHasValue] = useState(false);
    const emailInputRef = useRef<HTMLInputElement>(null);
    const { Text } = props;

    const handleChange = () => {
        if (emailInputRef.current) {
            setEmailHasValue(emailInputRef.current.value.length > 0);
        }
    }

    const formProps = {
        action:
            "https://galerie-rabouan-moussion.us4.list-manage.com/subscribe/post?u=c15ea40be5e354a792f3aae0f&amp;id=d0c169872d",
        method: "post",
        id: "mc-embedded-subscribe-form",
        name: "mc-embedded-subscribe-form",
        target: "_blank",
        novalidate: true
    }
    const emailInputProps = {
        type: "email",
        name: "EMAIL",
        id: "mce-EMAIL",
        placeholder: Language === "en" ? "Enter your email address" : "Entrez votre adresse mail",
        required: true
    };
    const hiddenInputProps = {
        type: "text",
        name: "b_c15ea40be5e354a792f3aae0f_d0c169872d",
        value: "",
        tabIndex: -1
    };

    const submitProps = {
        type: "submit",
        value: Language === "en" ? "Subscribe" : "S’abonner",
        name: "Subscribe",
        id: "mc-embedded-subscribe"
    };

    return (
        <div className={cls.newsletterContainer}>
            <ViewMonitor once={true}>{(intersect) =>
                <div className={classNames(cls.newsletterContainerInner, cls.hide, intersect && cls.show)}>
                    <div dangerouslySetInnerHTML={{ __html: Text }} />
                    <div id="mc_embed_signup">
                        <form
                            className="validate"
                            {...formProps}
                        >
                            <div id="mc_embed_signup_scroll">
                                <input
                                    ref={emailInputRef}
                                    className={cls.email}
                                    onChange={handleChange}
                                    {...emailInputProps}
                                />
                                {
                                    // real people should not fill this in and expect good things - 
                                    // do not remove this or risk form bot signups
                                }
                                <div
                                    style={{ position: 'absolute', left: '-5000px' }}
                                    aria-hidden="true"
                                >
                                    <input
                                        {...hiddenInputProps}
                                    />
                                </div>
                                <div
                                    className="clear"
                                >
                                    <input
                                        {...submitProps}
                                        className={classNames(cls.submitButton, emailHasValue && cls.emailFilled)} />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>}
            </ViewMonitor>
        </div>
    );
};

export default PanelNewsletter;


// WEBPACK FOOTER //
// ./src/Components/Panels/PanelNewsletter.tsx